import React, { useContext } from 'react';
import cn from 'classnames';
import { Button, Image } from '@ferris/react';
import { CardContent } from '@ferris/react/components/cards';
import { CompetitorUrlPropertyContext, ModalContext } from '../Context';
import { PropertyNotFoundModalProptypes } from '../properties';

const PropertyPlaybackModal = (props) => {
    const {
        rejectPropertyHandler,
        confirmPropertyHandler
    } = useContext(ModalContext);

    const {
        competitorUrlProperty
    } = useContext(CompetitorUrlPropertyContext);

    const {
        titlePropertyPlayback,
        instructions,
        ctaConfirmPropertyPlayback,
        ctaCancelPropertyPlayback
    } = props;

    return (
        <CardContent
            separatorBottom={false}
            separatorTop={false}
            classes={cn('competitor-url-modal', 'competitor-url-property-playback-modal')}
        >
            <p><b>{titlePropertyPlayback}</b></p>
            <div className={cn('competitor-url-property-display')}>
                <Image
                    classes={cn('competitor-url-property-image')}
                    src={competitorUrlProperty?.imageUrl}
                />
                <div className={cn('competitor-url-property-information')}>
                    <p className={cn('competitor-url-property-title')}>{competitorUrlProperty?.title}</p>
                    <p className={cn('competitor-url-property-address')}>
                        {competitorUrlProperty.addressLine1 && (
                            <>
                                <span>
                                    {competitorUrlProperty.addressLine1}
                                    {competitorUrlProperty.zipCode && (
                                        `, ${competitorUrlProperty.zipCode}`
                                    )}
                                </span>
                                <br />
                            </>
                        )}
                        {competitorUrlProperty.city && (
                            <>
                                <span>
                                    {competitorUrlProperty.city}
                                    ,
                                    {competitorUrlProperty.state}
                                </span>
                                <br />
                            </>
                        )}
                        {competitorUrlProperty.country && (
                            <span>
                                {competitorUrlProperty.country}
                            </span>
                        )}
                    </p>
                </div>
            </div>
            <p>{instructions}</p>
            <div className={cn('competitor-url-modal-actions')}>
                <Button
                    onClick={rejectPropertyHandler}
                    htmlButtonType="button"
                    type="utility"
                    variant="utility-standard"
                    data-wdio="competitor-url-button__reject"
                    id="competitor-url-button__reject"
                >
                    {ctaCancelPropertyPlayback}
                </Button>
                <Button
                    onClick={confirmPropertyHandler}
                    htmlButtonType="button"
                    type="primary"
                    data-wdio="competitor-url-button__confirm"
                    id="competitor-url-button__confirm"
                >
                    {ctaConfirmPropertyPlayback}
                </Button>
            </div>
        </CardContent>
    );
};

PropertyPlaybackModal.propTypes = PropertyNotFoundModalProptypes;

export default PropertyPlaybackModal;
